import { render, staticRenderFns } from "./cabinet-fl44-unknown-volume-proposal-card.vue?vue&type=template&id=004878c2&scoped=true&"
import script from "./cabinet-fl44-unknown-volume-proposal-card.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-unknown-volume-proposal-card.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-fl44-unknown-volume-proposal-card.vue?vue&type=style&index=0&id=004878c2&scoped=true&lang=css&"
import style1 from "./cabinet-fl44-unknown-volume-proposal-card.vue?vue&type=style&index=1&id=004878c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004878c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004878c2')) {
      api.createRecord('004878c2', component.options)
    } else {
      api.reload('004878c2', component.options)
    }
    module.hot.accept("./cabinet-fl44-unknown-volume-proposal-card.vue?vue&type=template&id=004878c2&scoped=true&", function () {
      api.rerender('004878c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/cards/cabinet-fl44-unknown-volume-proposal-card.vue"
export default component.exports